import React from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { State } from '../../reducer';
import { getExchangeTokenPartnerId } from './selectors';

import { ButtonLink } from '../../components/Buttons';
import { setLeaveInspect } from './actions';

const mapStateToProps = (state: State) => ({
    exchangeTokenPartnerId: getExchangeTokenPartnerId(state),
});

const mapDispatchToProps = {
    setLeaveInspect,
};

export interface BackToPartnerProps extends WithTranslation {
    setLeaveInspect: () => {};
    exchangeTokenPartnerId: string | undefined;
}

const BackToPartner =({ t, setLeaveInspect, exchangeTokenPartnerId }: BackToPartnerProps) => (
    <ButtonLink
        className="red"
        onClick={() => {
            setLeaveInspect();
        }}
        to={`/${exchangeTokenPartnerId}/sub-accounts`}
    >
        {t('partner.leave_inspect')}
    </ButtonLink>
);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BackToPartner));
